import {FC} from "react";
import {Header} from "../../components/Header";
import {Footer} from "../../components/Footer";
import {Hero} from "./components/Hero";
import {Features} from "./components/Features";
import {Screenshots} from "./components/Screenshots";
import {HowItWorks} from "./components/HowItWorks";
// import {Pricing} from "./components/Pricing"; // Pricing section temporarily hidden
import {Faq} from "./components/Faq";
import {FinalCta} from "./components/FinalCta";
import {PageRoute} from "../../types/PageRoute";

export const HomePage: FC = () => {
	return (
		<>
			<Header />
			<main>
				<Hero />
				<Features />
				<Screenshots />
				<HowItWorks />
				{/* <Pricing /> Pricing section temporarily hidden */}
				<Faq />
				<FinalCta />
			</main>
			<Footer />
		</>
	);
};

export const HomePageRoute: PageRoute = {
	component: <HomePage />,
	route: "/",
};
